import React, { useState }  from "react";
import InputField from "components/fields/InputField";
import Button from "components/button";
import { connect } from "react-redux";
import { loginRequest } from "../../redux/auth/authState";
import { Alert, Card, Checkbox } from 'antd';
import { Lock, LogIn, Mail } from "lucide-react";

const SignIn = ({ login, loading, error }) => {
  const [inputs, setInputs] = useState({});
  
  const handleChange = (event) => {
    const name = event.target.id;
    const value = event.target.value;
    setInputs(values => ({...values, [name]: value}));
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    try {   
      login({username: inputs.username, password:inputs.password});
    } catch (error) {
      console.error('Login failed:', error);
    }
  };

  return (
      <div className="relative max-w-[440px] items-center justify-center  md:mx-0 md:px-0 mt-8" >

      {/* Sign in section */}
      <Card 
        className="w-[400px] dark:border-gray-600 bg-card text-card-foreground flex flex-col gap-6 rounded-xl shadow-2xl border-2 border-purple-100">

          <div className="flex flex-col items-center justify-center mb-6 space-y-2">
            {/* <ApplicationName extra="flex justify-center items-center mb-4 w-[200px] ps-6" logoClass="logo-xs" /> */}
            <div className="w-16 h-16 bg-gradient-to-r from-purple-600 to-emerald-600 rounded-2xl flex items-center justify-center mx-auto mb-2">
              <LogIn className="w-8 h-8 text-white"/>
            </div>
            <h1 className="text-xl font-medium">
                Welcome
            </h1>
            <p className="text-base text-slate-500">
              Sign in to manage your applications
            </p>
          </div>

          <form className="form" onSubmit={handleSubmit}>
            <div className="h-full w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]">
            
              <InputField
                variant="auth"
                prefix={<Mail className="w-4 h-4 text-gray-600 transition-colors"/>}
                extra="mb-3"
                label="Email Address"
                placeholder="yourname@hyvidone.com"
                id="username"
                type="text"
                value={inputs.username}
                onChange={handleChange}
              />

              <InputField
                variant="auth"
                extra="mb-3"
                label="Password"
                prefix={<Lock className="w-4 h-4 text-gray-600 transition-colors"/>}
                placeholder="Enter your password"
                id="password"
                type="password"
                value={inputs.password}
                onChange={handleChange}
              />
              {error &&
              <div className="min-h-[18px] my-3">
                 <Alert className="p-3 text-red-700" message={error} type="error" showIcon /> 
              </div>  
              }

              <div className="mb-5 flex items-center justify-between px-2">
                <div className="flex items-start">
                  <Checkbox
                    className="remember-checkbox"
                  >
                    <span className="text-sm">
                      Remember me
                    </span>
                  </Checkbox>
                </div>
                {/* <a
                  className="text-sm text-gray-700 hover:text-gray-800 hover:text-theme-600 dark:text-white underline hover:underline"
                  href=" "
                >
                  Forgot password?
                </a> */}
              </div>  

              <Button type="submit" 
                      extra={`btn-gradient-emerald h-9
                              w-full ${loading && 'disabled'}`} disabled={loading}
              >
                Sign In
              </Button>
              <div className="text-center mt-8">
               <p className="text-sm text-gray-600">
                Don't have an account? <a href="/register" className="text-purple-600 hover:text-purple-700 font-medium">Create one</a>
                </p>
              </div>
              
            </div>

          </form>

      </Card>
    </div>
  );
}

const mapStateToProps = (state) => ({
  loading: state.auth.loading,
  error: state.auth.error,
});

const mapDispatchToProps = (dispatch) => ({
  login: (username, password) => dispatch(loginRequest(username, password)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SignIn);
